import { render, staticRenderFns } from "./EditPasswordSettings.vue?vue&type=template&id=6a7401c0&scoped=true"
import script from "./EditPasswordSettings.vue?vue&type=script&lang=js"
export * from "./EditPasswordSettings.vue?vue&type=script&lang=js"
import style0 from "./EditPasswordSettings.vue?vue&type=style&index=0&id=6a7401c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7401c0",
  null
  
)

export default component.exports